// extracted by mini-css-extract-plugin
export default {"locales":"kCiJ3Z4XzB9cLJDrDTVN7","tree":"uuLwbhS3iQBp8Q_BHucV4"};